import { httpClient } from '@/api/httpClient';
import {
  mapApiResourceToNotificationPreferences,
  mapUpdateItemsToApiPayload,
  type NotificationPreferences,
  type NotificationPreferencesApiResource,
  type NotificationPreferenceUpdateItem,
} from './notificationPreferencesApi.types';

const NOTIFICATION_PREFERENCES_PATH = '/me/notification-preferences';

export async function fetchNotificationPreferences(): Promise<NotificationPreferences> {
  const response = await httpClient.get<NotificationPreferencesApiResource>(
    NOTIFICATION_PREFERENCES_PATH
  );
  return mapApiResourceToNotificationPreferences(response.data);
}

export async function updateNotificationPreferences(
  items: NotificationPreferenceUpdateItem[]
): Promise<NotificationPreferences> {
  const response = await httpClient.put<NotificationPreferencesApiResource>(
    NOTIFICATION_PREFERENCES_PATH,
    mapUpdateItemsToApiPayload(items)
  );
  return mapApiResourceToNotificationPreferences(response.data);
}
